import { ApiHandlerDiscreteParameter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    getCurrentPromotionsDataView,
    getOrderPromotions,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { dispatchCheckoutEvent, dispatchPurchaseEvent } from "@store/Services/AnalyticsService"; // Store Custom Code

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

// Store Custom Code
export const StoreSendTracking: HandlerType = props => {
    // Do not do built-in tracking.
};

export const StoreExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess && props.parameter.onSuccess(props.apiResult.cart.id);
    dispatchCheckoutEvent(2, props.cartToUpdate, props.parameter.paymentMethod); // Store Custom Code
    /* Store Custom Code - Start */
    const state = props.getState();
    const currentPromotionsState = getCurrentPromotionsDataView(state);
    let orderPromotion;
    if (currentPromotionsState.value) {
        orderPromotion = getOrderPromotions(currentPromotionsState.value);
    }
    if (orderPromotion && orderPromotion.length && orderPromotion[0].name) {
        dispatchPurchaseEvent(
            props.apiResult.cart.orderNumber,
            props.cartToUpdate,
            props.apiResult?.billTo,
            orderPromotion[0].name,
        );
    } else {
        dispatchPurchaseEvent(props.apiResult.cart.orderNumber, props.cartToUpdate, props.apiResult?.billTo);
    }
    /* Store Custom Code - End */
};

replaceInChain(chain, SendTracking, StoreSendTracking); // Store Custom Code
replaceInChain(chain, ExecuteOnSuccessCallback, StoreExecuteOnSuccessCallback); // Store Custom Code
